export default __webpack_public_path__ + "static/media/S3.ce61036f.svg";